import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { makeEnvironmentProviders } from '@angular/core';
import { FirewallBlockInterceptor } from '../interceptors/firewall-block.interceptor';

/**
 *
 * @param standaloneInterceptors use false in legacy applications importing `HttpClientModule`, true in standalone applications using `provideHttpClient(withInterceptors(firewallBlockInterceptor))`
 * @returns
 */
export const provideFirewallBlock = (standaloneInterceptors = true) =>
    makeEnvironmentProviders([
        standaloneInterceptors
            ? FirewallBlockInterceptor
            : {
                  provide: HTTP_INTERCEPTORS,
                  useClass: FirewallBlockInterceptor,
                  multi: true,
              },
    ]);
